import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowDocumentsReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.RecievedDocumentInfoList}
				customHeaders={{
					"DocumentTypeCode": "کد مدرک",
					"DocumentTypeTitle": "نام مدرک",
					"SerialNumber": "شماره سریال مدرک",
					"Description": "توضیحات"
				}}		
			/>				
			<br/>	
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.DocumentFieldPropertyInfoList.map((item, index) => ({ ...item, ID: index + 1 }))}
				customHeaders={{
					"ID": "ردیف",
					"DocumentTypeTitle": "عنوان فیلد",
					"DocumentValue": "مقدار فیلد"
				}}		
			/>				
			<br/>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.DocumentActionInfoList}
				customHeaders={{
					"ActionIdentifierTitle": "نوع نامه",
					"User": "نام کاربر",
					"ActionDate": "زمان اقدام",
					"SerialNumber": "نحوه اقدام",
					"ActionTitle": "شماره نامه",
					"DocumentTitle": "آخرین اقدام پرونده"
				}}		
			/>				
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
